import { ScrollingModule } from '@angular/cdk/scrolling';
import { TextFieldModule } from '@angular/cdk/text-field';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsMultiSelectModule } from '@lcs/shared/multi-select';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AutoAttendantKeyListModule } from 'src/app/common-components/auto-attendant-key-list/auto-attendant-key-list.module';
import { AutoAttendantPromptListModule } from 'src/app/common-components/auto-attendant-prompt-list/auto-attendant-prompt-list.module';
import { CallHistoryFilterModule } from 'src/app/common-components/call-history-filters/call-history-filter.module';
import { CardLayoutModule } from 'src/app/common-components/card-layout/card-layout.module';
import { TwoColumnLayoutModule } from 'src/app/common-components/column-layouts/two-column-layout/two-column-layout.module';
import { DeleteExtensionDialogModule } from 'src/app/common-components/delete-extension-dialog/delete-extension-dialog.module';
import { DetailLinksModule } from 'src/app/common-components/detail-links/detail-links.module';
import { ResizeOnTabChangeDirectiveModule } from 'src/app/common-components/detail/resize-on-tab-change-directive.module';
import { TabRouterDirectiveModule } from 'src/app/common-components/detail/tab-router-directives.module';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { FormFooterModule } from 'src/app/common-components/form-footer/form-footer.module';
import { LcsChipMultiSelectModule } from 'src/app/common-components/multi-select/multi-select.module';
import { PhoneIssuesChipAndMenuModule } from 'src/app/common-components/phone-issues-chip-and-menu/phone-issues-chip-and-menu.module';
import { QueuePeriodicAnnouncementListModule } from 'src/app/common-components/queue-periodic-announcement-list/queue-periodic-announcement-list.module';
import { TooltipModule } from 'src/app/common-components/tooltip/tooltip.module';
import { UpdateDetailsModule } from 'src/app/common-components/update-details/update-details.module';
import { FormatMailboxMessageCountPipeModule } from 'src/app/pipes/format-mailbox-message-count/format-mailbox-message-count-pipe.module';
import { LocationModule } from 'src/app/pipes/location/location.module';
import { AgentStatusPipeModule } from 'src/app/pipes/queue-calls-status-pipe/queue-calls-status-pipe.module';
import { FormatPhoneNumbersPipeModule } from '../../pipes/format-phone-numbers/format-phone-numbers-pipe.module';
import { AddSpacesPipeModule } from '../../pipes/split-enum-strings/add-spaces-pipe.module';
import { CallLogsRegisterModule } from '../call-logs-register/call-logs-register.module';
import { CallLogsRegisterComponent } from '../call-logs-register/containers/call-logs-register.component';
import { ErrorPageModule } from '../error-page/error-page.module';
import { ExtensionTimeBasedRoutesModule } from '../extension-time-based-routes/extension-time-based-routes.module';
import { IncomingFaxRegisterModule } from '../fax-register/incoming-fax-register/incoming-fax-register.module';
import { OutgoingFaxRegisterModule } from '../fax-register/outgoing-fax-register/outgoing-fax-register.module';
import { MailboxDetailStandaloneModule } from '../mailbox-details/mailbox-detail.module';
import { ExtensionPhoneRegisterModule } from '../phones/extension-phone-register/extension-phone-register.module';
import { QueueHistoryRegisterModule } from '../queue-history-register/queue-history-register.module';
import { ChangeDNDStatusComponent } from './containers/change-dnd-status/containers/change-dnd-status.component';
import { ExtensionDetailComponent } from './containers/extension-detail.component';
import { ExtensionDetailEffects } from './state/extension-detail.effects';
import * as fromExtensionDetail from './state/extension-detail.reducer';
import { ExtensionAutoAttedantDetailLeftColumnComponent } from './views/extension-auto-attendant-sections/extension-auto-attendant-detail-left-column.component';
import { ExtensionAutoAttendantDetailsComponent } from './views/extension-auto-attendant-sections/extension-auto-attendant-details.component';
import { ExtensionDetailViewComponent } from './views/extension-detail-view.component';
import { ExtensionExternalForwardDetailLeftColumnComponent } from './views/extension-external-forward-sections/extension-external-forward-detail-left-column.component';
import { ExtensionExternalForwardDetailsComponent } from './views/extension-external-forward-sections/extension-external-forward-details.component';
import { ExtensionFaxDetailLeftColumnComponent } from './views/extension-fax-sections/extension-fax-detail-left-column.component';
import { ExtensionFaxDetailsComponent } from './views/extension-fax-sections/extension-fax-details.component';
import { FaxEmailsModule } from './views/extension-fax-sections/fax-emails-tab/fax-emails.module';
import { ExtensionFindMeFollowMeStepsModule } from './views/extension-find-me-follow-me-sections/extension-find-me-follow-me-steps.module';
import { ExtensionFmFmDetailLeftColumnComponent } from './views/extension-fmfm-sections/extension-fmfm-detail-left-column.component';
import { ExtensionFmFmDetailsComponent } from './views/extension-fmfm-sections/extension-fmfm-details.component';
import { ExtensionHuntGroupDetailLeftColumnComponent } from './views/extension-hunt-group-sections/extension-hunt-group-detail-left-column.component';
import { ExtensionHuntGroupDetailsComponent } from './views/extension-hunt-group-sections/extension-hunt-group-details.component';
import { ExtensionMailboxDetailLeftColumnComponent } from './views/extension-mail-box/extension-mail-box-detail-left-column.component';
import { ExtensionMailboxDetailsComponent } from './views/extension-mail-box/extension-mail-box-details.component';
import { ExtensionPagingGroupDetailLeftColumnComponent } from './views/extension-paging-group-sections/extension-paging-group-detail-left-column.component';
import { ExtensionPagingGroupDetailsComponent } from './views/extension-paging-group-sections/extension-paging-group-details.component';
import { ExtensionPhoneDetailLeftColumnComponent } from './views/extension-phone-sections/extension-phone-detail-left-column.component';
import { ExtensionPhoneDetailsComponent } from './views/extension-phone-sections/extension-phone-details.component';
import { ExtensionQueueDetailLeftColumnComponent } from './views/extension-queue-sections/extension-queue-detail-left-column.component';
import { ExtensionQueueDetailsComponent } from './views/extension-queue-sections/extension-queue-details.component';
@NgModule({
   declarations: [
      ExtensionDetailViewComponent,
      ExtensionDetailComponent,
      ExtensionAutoAttedantDetailLeftColumnComponent,
      ExtensionAutoAttendantDetailsComponent,
      ExtensionPhoneDetailsComponent,
      ExtensionPhoneDetailLeftColumnComponent,
      ExtensionExternalForwardDetailLeftColumnComponent,
      ExtensionExternalForwardDetailsComponent,
      ExtensionHuntGroupDetailLeftColumnComponent,
      ExtensionHuntGroupDetailsComponent,
      ExtensionMailboxDetailLeftColumnComponent,
      ExtensionMailboxDetailsComponent,
      ExtensionQueueDetailsComponent,
      ExtensionQueueDetailLeftColumnComponent,
      ExtensionFaxDetailsComponent,
      ExtensionFaxDetailLeftColumnComponent,
      ExtensionFmFmDetailLeftColumnComponent,
      ExtensionFmFmDetailsComponent,
      ExtensionPagingGroupDetailLeftColumnComponent,
      ExtensionPagingGroupDetailsComponent,
      ChangeDNDStatusComponent,
   ],
   exports: [
      ExtensionPhoneDetailsComponent,
      ExtensionAutoAttendantDetailsComponent,
      CallLogsRegisterComponent,
      ExtensionExternalForwardDetailsComponent,
      ExtensionHuntGroupDetailsComponent,
      ExtensionMailboxDetailsComponent,
      ExtensionQueueDetailsComponent,
      ExtensionFaxDetailsComponent,
      ExtensionFmFmDetailsComponent,
      ExtensionPagingGroupDetailsComponent,
   ],
   imports: [
      CommonModule,
      CallHistoryFilterModule,
      CallLogsRegisterModule,
      OutgoingFaxRegisterModule,
      IncomingFaxRegisterModule,
      PhoneIssuesChipAndMenuModule,
      FormsModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      MatCheckboxModule,
      MatInputModule,
      MatIconModule,
      MatMenuModule,
      MatDialogModule,
      MatButtonModule,
      MatTooltipModule,
      MatSlideToggleModule,
      LcsLoadingOverlayModule,
      LcsCallStatePipeModule,
      TwoColumnLayoutModule,
      FormFooterModule,
      MatSelectModule,
      FaxEmailsModule,
      EntitySelectModule,
      MatTabsModule,
      RouterModule,
      DetailLinksModule,
      ExtensionPhoneRegisterModule,
      CardLayoutModule,
      TooltipModule,
      UpdateDetailsModule,
      AutoAttendantPromptListModule,
      AutoAttendantKeyListModule,
      QueuePeriodicAnnouncementListModule,
      ExtensionTimeBasedRoutesModule,
      ExtensionFindMeFollowMeStepsModule,
      LcsChipMultiSelectModule,
      LcsMultiSelectModule,
      QueueHistoryRegisterModule,
      ScrollingModule,
      TextFieldModule,
      ErrorPageModule,
      MailboxDetailStandaloneModule,
      StoreModule.forFeature(fromExtensionDetail.extensionDetailFeatureKey, fromExtensionDetail.reducer),
      EffectsModule.forFeature([ExtensionDetailEffects]),
      LocationModule,
      FormatMailboxMessageCountPipeModule,
      AddSpacesPipeModule,
      MatRadioModule,
      DeleteExtensionDialogModule,
      FormatPhoneNumbersPipeModule,
      AgentStatusPipeModule,
      TabRouterDirectiveModule,
      ResizeOnTabChangeDirectiveModule,
   ],
})
export class ExtensionDetailModule {}
